module.exports = __webpack_public_path__ + "img/375.18d6edf9.jpg";